import React from 'react';
import { Container, Row, Col, Card } from "react-bootstrap";
import NewNav from '../components/NewNav.jsx';
import Banner from '../components/Banner';
import BannerCards from '../components/BannerCards';
import Footer from '../components/Footer';

import pcbImg from "../images/mainpc.jpg";
import pro1 from "../images/pro1.jpeg";
import pro2 from "../images/pro2.jpeg";
import pro3 from "../images/pro3.jpeg";
import pro4 from "../images/pro4.jpeg";
import pro5 from "../images/pro5.jpeg";
import pro6 from "../images/pro6.jpeg";

function LedBulb() {
  return (
    <div className='led-bulb-page'>
      <NewNav />
       <div className='main-banner-wrapper'>
              <div className="banner banner_OUR">
            <div className="overlay"></div>
            <div className="dots"></div>
             <Container className="content">
              <h1>{'PCB'}</h1>
            </Container>
          </div>
          </div>
       <div className='consumer-cards-wrapper'>
      <Container className="my-5">
        <Row className="justify-content-center">
           <Col md={3} className="mb-4" >
             <Card className="custom-card">
               <Card.Body>
                 <Card.Title>{'Bulb 11 Watt'}</Card.Title>
               </Card.Body>
               <Card.Img
                 style={{ width: "100px", height: "210px", objectFit: "contain" }}
                 variant="top"
                 src={pro1} 
                 alt={ 'Bulb 11 Watt'}
                 className="custom-card-img"
               />
             </Card>
         </Col>
          <Col md={3} className="mb-4" >
             <Card className="custom-card">
               <Card.Body>
                 <Card.Title>{'Bulb 40 Watt'}</Card.Title>
               </Card.Body>
               <Card.Img
                 style={{ width: "100px", height: "210px", objectFit: "contain" }}
                 variant="top"
                 src={pro2} 
                 alt={ 'watt'}
                 className="custom-card-img"
               />
             </Card>
         </Col>
          <Col md={3} className="mb-4" >
             <Card className="custom-card">
               <Card.Body>
                 <Card.Title>{'Bulb 24 Watt'}</Card.Title>
               </Card.Body>
               <Card.Img
                 style={{ width: "100px", height: "210px", objectFit: "contain" }}
                 variant="top"
                 src={pro3} 
                 alt={ 'watt'}
                 className="custom-card-img"
               />
             </Card>
         </Col>
          <Col md={3} className="mb-4" >
             <Card className="custom-card">
               <Card.Body>
                 <Card.Title>{'Bulb 20 Watt'}</Card.Title>
               </Card.Body>
               <Card.Img
                 style={{ width: "100px", height: "210px", objectFit: "contain" }}
                 variant="top"
                 src={pro4} 
                 alt={ 'watt'}
                 className="custom-card-img"
               />
             </Card>
         </Col>
        </Row>
      </Container>
       <Container className="my-5">
        <Row className="justify-content-center">
           <Col md={3} className="mb-4" >
             <Card className="custom-card">
               <Card.Body>
                 <Card.Title>{'Bulb 30 Watt'}</Card.Title>
               </Card.Body>
               <Card.Img
                 style={{ width: "100px", height: "210px", objectFit: "contain" }}
                 variant="top"
                 src={pro5} 
                 alt={ 'watt'}
                 className="custom-card-img"
               />
             </Card>
         </Col>
          <Col md={3} className="mb-4" >
             <Card className="custom-card">
               <Card.Body>
                 <Card.Title>{'Downlight 12 Watt'}</Card.Title>
               </Card.Body>
               <Card.Img
                 style={{ width: "100px", height: "210px", objectFit: "contain" }}
                 variant="top"
                 src={pro6} 
                 alt={ 'watt'}
                 className="custom-card-img"
               />
             </Card>
         </Col>
        </Row>
      </Container>
    </div>
      <Footer />
    </div>
  );
}

export default LedBulb;
